import React from 'react';

const SkillCourse = () => {
    return (
        <div className='py-12'>
            <h1 className='text-2xl  font-bold '>04.<span className='text-primary'>Top_Skill_Courses</span></h1>
            <h1 class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400 py-2">I have done more then 20+ course but this three courses change my programming life. </h1>

            <div className='grid mt-4 justify-content-center sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>


            <div className="container1">
            <div className="card">
                <div className="content2">
                <h1 className='font-bold'>01</h1>
                            <h2 className='text-2xl text-gray-300 h1p'>Complete Web development With Jankar Mahbub</h2>
                <h3 className="text-secondary font-bold mt-2">Programming Hero Course</h3>
                <a target="_blank" href="https://drive.google.com/file/d/1sSwSsAwKIGv2gdYyUkBFy30zZoB21xmv/view?usp=share_link">
                <h3 className="text-secondary mt-2 h1p">See Certificate</h3></a>
                </div>
           
                
             </div>
            </div>
            <div className="container1">
            <div className="card">
                <div className="content2">
                <h1 className='font-bold'>02</h1>
                            <h2 className='text-2xl text-gray-300 h1p'> Web design UI/UX Design With 10 minutes School</h2>
                <h3 className="text-secondary font-bold mt-2">10 Minuts School course</h3>
                <a target="_blank" href="https://drive.google.com/file/d/1jPzYS9fY10u0U6sIOXrEA0xYu0leDDIF/view?usp=share_link">
                <h3 className="text-secondary mt-2 h1p">See Certificate</h3></a>
                </div>
           
                
             </div>
            </div>
            <div className="container1">
            <div className="card">
                <div className="content2">
                <h1 className='font-bold'>03</h1>
                            <h2 className='text-2xl text-gray-300 h1p'>English Communication Expert by LinkedIn </h2>
                <h3 className="text-secondary font-bold mt-2">linkedin.com</h3>
                            <a target="_blank" href="https://drive.google.com/file/d/1Zy0y8ETLdV5tmA5_290iEWWF2mDGw5hH/view?usp=share_link">
                <h3 className="text-secondary mt-2 h1p">See Certificate</h3></a>
                </div>
           
                
             </div>
            </div>
          
            
            
                
             
           

            

           
           
         






            </div>



        
           

        </div>
    );
};

export default SkillCourse;